import React, { Component } from 'react';
import { Row, Col } from "react-bootstrap";

import ModalForm from "../../components/Modal/ModalForm";

import { AlumnosXSemestre } from '../../funciones/functionEstadistica';
import SeccionesSem from './SeccionesSem';

class AlumnosSemestre extends Component {
    state = {
        datosC: <div align = "center" className="text-danger"><i className="fa fa-spinner fa-spin"></i> Cargando datos</div>,
        datosT: "",
        modal: false
    }

    componentDidMount = () => {
        setTimeout(() => {
            AlumnosXSemestre(this.props.datos.value, (resp) => {
                let porcentajeM = (resp.M * 100) / resp.Total;
                let porcentajeF = (resp.F * 100) / resp.Total;
    
                let contenido = <Row>
                                    <Col md = {12}>
                                        <div className="custom-alert-warning" style={{fontSize: 11}}>Datos estadísticos de <strong>{this.props.datos.label}</strong></div>
                                    </Col>
                                    <Col md = {6} className="custom-mt-10">
                                        <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted"><strong>({resp.F})</strong> estudiantes</span></div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                                aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                                                {Math.round(porcentajeF)}%
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md = {6} className="custom-mt-10">
                                        <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted"><strong>({resp.M})</strong> estudiantes</span></div>
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                                aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                                                {Math.round(porcentajeM)}%
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                
                this.setState({
                    datosC: contenido,
                    datosT: <div>
                                <div style={{fontSize:12}} className="text-danger">Inscritos:</div>
                                <div style={{fontSize:12}} className="text-muted"><strong>({resp.Total})</strong> estudiantes</div>
                            </div>
                })
            })
        }, this.props.time);   
    }

    showModal = () => {
        const { modal } = this.state;
        let {datos} = this.props;
        if (modal === false) return null;

        return (
            <ModalForm
                isopen =  {modal}
                titulo = {<div style={{fontSize:14}}>Secciones de <strong>{datos.label}</strong></div>}
                contenido = {<SeccionesSem semestre = {datos.value}/>}
                cerrar = {() => {this.setState({modal: false})}}
            />
        );
    }

    render() {
        let {datos} = this.props;
        let {datosC, datosT} = this.state;
        const styles = {
            padding: 10, fontSize: 12
        }

        const styles2 = {
            padding: 10, fontSize: 11
        }
        
        return (
            <React.Fragment>
                <tr>
                    <td style={styles2}>
                        <strong>{datos.label}</strong>
                        {datosT}
                        <div align="right">
                            <button className="btn btn-primary btn-xs" onClick = {() => {this.setState({modal: true})}} title="Muestra los datos estadísticos de las secciones del semestre" style={{borderWidth: 1}}><i className="fa fa-book"></i>Ver Secciones</button>
                        </div>
                    </td>
                    <td style={styles}>{datosC}</td>
                </tr>
                {this.showModal()}
            </React.Fragment>
        );
    }
}
 
export default AlumnosSemestre;


// WEBPACK FOOTER //
// ./src/views/Opciones/AlumnosSemestre.jsx